import { useCallback, useMemo } from 'react'
import {
  useDraggable as useDndKitDraggable,
  UseDraggableArguments,
} from '@dnd-kit/core'
import { useIsTemplateAttributeMultiSelected } from '@/pages/DocumentPage/features/templateAttributesMultiSelect/useIsTemplateAttributeMultiSelected'
import { useDocumentState } from '@/state'

export const useMultiSelectDraggable = (args: UseDraggableArguments) => {
  const draggable = useDndKitDraggable(args)
  const isMultiSelected = useIsTemplateAttributeMultiSelected({
    templateAttributeId: args.id as string,
  })
  // Invariant: non-selected items should not re-render on every drag delta tick.
  const deltaX = useDocumentState((state) =>
    isMultiSelected ? state.multiSelectDelta.x : 0,
  )
  const deltaY = useDocumentState((state) =>
    isMultiSelected ? state.multiSelectDelta.y : 0,
  )

  const onMouseDown = useCallback(
    (e: any) => {
      e.stopPropagation()

      const onDraggableMouseDown = draggable?.listeners?.onMouseDown
      if (onDraggableMouseDown && typeof onDraggableMouseDown === 'function') {
        onDraggableMouseDown(e)
      }
    },
    [draggable?.listeners?.onMouseDown],
  )

  const transform = useMemo(
    () => ({
      ...draggable.transform,
      x: isMultiSelected ? deltaX : draggable.transform?.x,
      y: isMultiSelected ? deltaY : draggable.transform?.y,
    }),
    [draggable.transform, isMultiSelected, deltaX, deltaY],
  )

  return {
    ...draggable,
    transform,
    listeners: {
      ...draggable.listeners,
      onMouseDown,
    },
  }
}
